import styled from 'styled-components';

export const Container = styled.div`
  h2, span {
    color: #ECFa00;
    font-size: 1.5em;
  }
`;
